module.exports = __webpack_public_path__ + "img/gartek-services-electrcal.c0d355cb.jpeg";